import { render, staticRenderFns } from "./Paquimetria.vue?vue&type=template&id=0c1eae08"
import script from "./Paquimetria.vue?vue&type=script&lang=js"
export * from "./Paquimetria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports